import { likeCarSuccess } from '../actions/car.actions';
import { likeRealEstateSuccess } from '../actions/real-estate.actions';
import { createReducer, on } from '@ngrx/store';
import { User } from '../../models/user.model';
import * as AuthActions from '../actions/auth.actions';
import { clearAuthUser, updateAuthUserLanguage } from '../actions/auth.actions';

export interface AuthState {
  user: User | null;
  accessToken: string | null;
  isLoggedIn: boolean;
  logingIn: boolean;
  loadingUser: boolean;
  error: any | null;
}

export const initialAuthState: AuthState = {
  user: null,
  accessToken: null,
  isLoggedIn: false,
  logingIn: false,
  loadingUser: false,
  error: null,
};

export const authReducer = createReducer(
  initialAuthState,

  on(likeCarSuccess, (state, { car, userId }) => {
    if (!state.user || state.user.id !== userId) return state;
    const items = state.user.likedCars ?? [];
    return { ...state, user: { ...state.user,
      cars: state.user.cars?.map(item => item.id === car.id ? { ...item, ...car } : item),
      likedCars: car.liked
        ? items.some(item => item.id === car.id) ? items.map(item => item.id === car.id ? car : item) : [...items, car]
        : items.filter(item => item.id !== car.id),
    } };
  }),
  on(likeRealEstateSuccess, (state, { realEstate, userId }) => {
    if (!state.user || state.user.id !== userId) return state;
    const items = state.user.likedRealEstates ?? [];
    return { ...state, user: { ...state.user,
      realEstates: state.user.realEstates?.map(item => item.id === realEstate.id ? { ...item, ...realEstate } : item),
      likedRealEstates: realEstate.liked
        ? items.some(item => item.id === realEstate.id) ? items.map(item => item.id === realEstate.id ? realEstate : item) : [...items, realEstate]
        : items.filter(item => item.id !== realEstate.id),
    } };
  }),
  // Init
  on(AuthActions.initAuth, (state) => ({ ...state, loadingUser: true })),

  // login
  on(AuthActions.login, (state) => ({ ...state, logingIn: true, loadingUser: true, error: null })),
  on(AuthActions.loginWithGmail, (state) => ({
    ...state,
    logingIn: true,
    loadingUser: true,
    error: null,
  })),
  on(AuthActions.loginWithFacebook, (state) => ({
    ...state,
    logingIn: true,
    loadingUser: true,
    error: null,
  })),
  on(AuthActions.loginSuccess, (state, { accessToken }) => ({
    ...state,
    accessToken,
    logingIn: false,
    error: null,
  })),
  on(AuthActions.refreshSuccess, (state, { accessToken }) => ({
    ...state,
    accessToken,
    logingIn: false,
    error: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    logingIn: false,
    loadingUser: false,
    error,
  })),

  // load user
  on(AuthActions.loadUser, (state) => ({ ...state, loadingUser: true, error: null })),
  on(AuthActions.loadUserSuccess, (state, { user }) => ({
    ...state,
    user,
    isLoggedIn: true,
    loadingUser: false,
    error: null,
  })),
  on(AuthActions.loadUserFailure, (state, { error }) => ({ ...state, loadingUser: false, error })),

  // logout
  on(AuthActions.logout, (state) => ({ ...initialAuthState, loadingUser: false })),

  on(clearAuthUser, (state) => ({
    ...state,
    user: null,
    accessToken: null,
    loadingUser: false,
    isLoggedIn: false,
  })),

  on(updateAuthUserLanguage, (state, { language }) => ({
    ...state,

    user: state.user
      ? {
          ...state.user,
          language,
        }
      : null,
  }))
);
